module.exports = __webpack_public_path__ + "static/media/powered-by-foursquare-grey.cdd335d8.png";